module.exports = __webpack_public_path__ + "img/good8.357da23d.jpg";